export enum Activity {
    Choir = "Choir",
    IT = "IT",
    Media = "Media",
    Theatre = "Theatre",
    VisualArts = "VisualArts",
    Research = "Research"
}
